import styled from 'styled-components';

export const ProfileSC = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;